import { TChannelType, TRoomUsageAlertChannelSettingsProps } from "../types";
import { Channel, FeatureActivation, FeatureSetting, FeatureTitle, Line, Section } from "../index.styles";
import UI from "@mile-meeting/mile-ui";
import { useEffect, useState } from "react";
import { roomUsageAlertChannelSettingServices } from "../services";
import { useToast } from "hook/useToast";
import { MainPolicySettingBlock, PolicyCustomizeSection } from "uis/Section";

const RoomUsageAlertChannelSetting = (props: TRoomUsageAlertChannelSettingsProps): JSX.Element => {
  const { channel, isShow, isSlackConnected } = props;
  const [selectedChannel, setSelectedChannel] = useState<TChannelType>("EMAIL");
  const { showToast } = useToast();
  const services = roomUsageAlertChannelSettingServices;

  useEffect(() => {
    setSelectedChannel(channel);
  }, [channel]);

  if (!isShow) return <></>;
  return (
    <PolicyCustomizeSection title="회의실 이용 확인 알림">
      <MainPolicySettingBlock
        title="회의실 이용 확인 알림 채널"
        description="설정한 채널로 당일의 회의실 예약 내역에 대한 이용 확인 알림을 전송합니다. 회의실 이용 확인 알림은
              비활성화가 불가능합니다."
        rightChildren={
          <Channel>
            <div className="item" onClick={() => services.onChangeChannel("EMAIL", showToast, setSelectedChannel)}>
              <UI.Radio selected={selectedChannel === "EMAIL"} />
              <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                E-mail
              </UI.Typography>
            </div>
            <div
              className="item"
              onClick={() => {
                if (isSlackConnected) {
                  services.onChangeChannel("SLACK", showToast, setSelectedChannel);
                } else {
                  showToast("Slack 미연동 상태입니다. 서비스 연동 관리에서 Slack을 연동해 주세요.", "warning");
                }
              }}
            >
              <UI.Radio selected={selectedChannel === "SLACK"} disabled={!isSlackConnected} />
              <UI.Typography
                type="body01 normal"
                fontStyle="regular"
                color={isSlackConnected ? "var(--alias-color-label-normal)" : "var(--alias-color-label-disabled)"}
              >
                Slack
              </UI.Typography>
            </div>
          </Channel>
        }
      />
    </PolicyCustomizeSection>
  );
};

export default RoomUsageAlertChannelSetting;
